import { fromJS } from 'immutable';

import {
    SET_ACTIVITY_RESTORE_INFO,
    SET_ASSETS_SERVER,
    SET_CURRENT_APP,
    SET_ZOOM_OVERLAY,
    SET_ETAG,
    SET_FREE_GAMES,
    SET_IMAGE_ZOOM,
    SET_KEYBOARD_HANDLER_ID,
    SET_POP_LAST_VIEW_URL,
    TOGGLE_HANDS_UP,
    TOGGLE_LOCKED,
    UPDATE_APPSTATE,
    UPDATE_IMAGE_ZOOM,
    UPDATE_ZOOM_OVERLAY,
    DISABLE_TABLES_GAMES_TIMER,
} from './actions';

export const APPSTATE_KEY = 'appState';

const initState = fromJS({
    freeGames: [],
    handsUp: false,
    activeTasks: null,
    lockTasks: false,
    lastScreenLockUpdate: null,
    locked: false,
    keyboardHandlerId: null,
    imageZoom: null,
    popLastViewURL: null,
    zoomOverlay: null,
    disableTablesGamesTimer: false,
});

export function appStateReducer(state = initState, action) {
    switch (action.type) {
        case UPDATE_APPSTATE:
            return state.set(action.key, action.value);
        case SET_CURRENT_APP:
            return state.set('currentApp', action.app);
        case TOGGLE_HANDS_UP:
            return state.set('handsUp', action.status);
        case TOGGLE_LOCKED:
            if (!action.timestamp) {
                return state.set('locked', action.status).set('lastScreenLockUpdate', null);
            }
            const lastScreenLockUpdate = state.get('lastScreenLockUpdate');
            if (!lastScreenLockUpdate || action.timestamp.isAfter(lastScreenLockUpdate)) {
                return state
                    .set('locked', action.status)
                    .set('lastScreenLockUpdate', action.timestamp);
            }
            return state;
        case SET_FREE_GAMES:
            return state.set('freeGames', action.freeGames);
        case SET_ACTIVITY_RESTORE_INFO:
            return state.set('activityRestoreInfo', action.activityRestoreInfo);
        // NOTE: We still need this as discoveryweb uses the asset token to talk to speechserver. It's not used for assets anymore.
        case SET_ASSETS_SERVER:
            return state
                .set('assetsServer', action.server)
                .set('assetsToken', action.server.get('token'));
        case SET_ETAG:
            return state.set('etag', action.etag);
        case SET_KEYBOARD_HANDLER_ID:
            return state.set('keyboardHandlerId', action.id);
        case SET_IMAGE_ZOOM:
            // Note: we can't open a new image zoom if one is already showing:
            if (action.zoomSpec && state.get('imageZoom')) {
                return state;
            }
            return state.set('imageZoom', action.zoomSpec);
        case UPDATE_IMAGE_ZOOM:
            const currentZoom = state.get('imageZoom');
            if (!currentZoom) {
                return state;
            }
            return state.set(
                'imageZoom',
                currentZoom
                    .set('src', '')
                    .set('assetId', '')
                    .merge(action.zoomSpec),
            );
        case SET_ZOOM_OVERLAY:
            if (action.zoomSpec && state.get('zoomOverlay')) {
                return state;
            }
            return state.set('zoomOverlay', action.zoomSpec);
        case UPDATE_ZOOM_OVERLAY:
            const currentZoomOverlay = state.get('zoomOverlay');
            if (!currentZoomOverlay) {
                return state;
            }
            return state.set('zoomOverlay', { ...currentZoomOverlay, ...action.zoomSpec });
        case SET_POP_LAST_VIEW_URL:
            return state.set('popLastViewURL', action.url);
        case DISABLE_TABLES_GAMES_TIMER:
            return state.set('disableTablesGamesTimer', action.disableTablesGamesTimer);
    }
    return state;
}
